module.exports = __webpack_public_path__ + "static/media/supply-chain-decisions.0d6d064d.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/supply-chain-decisions.png
// module id = 2675
// module chunks = 0